import { Grid } from "@material-ui/core";
import { Tooltip, Typography } from "@mui/material";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as CancelVisitIcon } from "../../../src/assets/CancelVisit.svg";
import { ReactComponent as CancelIconSvg } from "../../assets/USA_Images/login_images_visitor/CancelIcon1.svg";
import DialogBox from "../../components/DialogBoxComponent/DialogBox";
import Toast from "../../components/ToastContainer/CustomToast";
import { cancelVisitorPreRegistrationInvite } from "../../slices/Invitations/InvitationsSlice";
import { ThemeContext } from "../../theme/ThemeContext";

export default function CancelPreRegistration(props) {
  const { open, handleClose } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { darkMode } = useContext(ThemeContext);
  const [payload, setPayload] = React.useState({
    id: props.CancelId,
    firstName: props.CancelFirstName,
  });

  const handleSubmit = () => {
    dispatch(cancelVisitorPreRegistrationInvite(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0068") {
          Toast(t("INVITATIONFORM017"), "success");
          handleClose(false);
          if (props.loadData) {
            props.loadData();
          }
        } else {
          Toast(data.message, "error");
        }
      })
      .catch((error) => {
        Toast(error?.message || "Something went wrong.", "error");
      });
  };
  const handleTextOverflow = (text) => {
    if (text && text.length > 10) {
      return text.substring(0, 25) + "...";
    } else {
      return text;
    }
  };

  return (
    <>
      <DialogBox
        Header={
          <span style={{ fontSize: "21px", color: darkMode ? "#fff" : "" }}>
            {t("ADD030")}
          </span>
        }
        acceptText={t("CONFIRM")}
        cancelText={t("COMMON008")}
        fullWidth={true}
        onClose={() => handleClose(false)}
        cancel={handleClose}
        onSubmit={handleSubmit}
        open={open}
      >
        <Grid
          container
          justifyContent="center"
          direction="column"
          alignItems={"center"}
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "",
          }}
        >
          <Grid>{darkMode ? <CancelIconSvg /> : <CancelVisitIcon />}</Grid>
          <Grid>
            <Grid
              style={{
                wordWrap: "break-word",
                opacity: 1,
                textAlign: "center",
                display: "flex",
                flexDirection: "row",
                fontSize: "17px",
                marginTop: "15px",
                color: darkMode ? "#fff" : "",
              }}
            >
              <Typography
                style={{
                  color: darkMode ? "#fff" : "#242424",
                  marginRight: "4px",
                  fontSize: "15px",
                }}
              >
                {t("ADD029")}
              </Typography>
              <Tooltip title={payload.firstName}>
                <Typography
                  style={{
                    fontWeight: "bold",
                    marginRight: "4px",
                    fontSize: "15px",
                  }}
                >
                  {handleTextOverflow(payload.firstName)}
                </Typography>
              </Tooltip>
              ?
            </Grid>
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
